import React from "react";
import { Spinner } from "react-bootstrap";

export function AbpnSpinner() {
    return <div className="d-flex justify-content-center"><Spinner animation={"border"}></Spinner></div>;
}

export default AbpnSpinner;
